import { styled } from '@withjoy/joykit';

/**
 * The flag-off embed's iframe. A plain styled element rather than `Box as="iframe"`: JoyKit's Box
 * blocks the `loading` prop (Button uses it for a spinner), so `loading="lazy"` would never reach
 * the DOM. Fills the frame and ignores pointers, like the optimized player's iframe.
 */
export const LegacyEmbedIframe = styled('iframe')`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
`;
